const PAYLOAD_TOO_LARGE =
  'Por segurança, cada envio pode ter no máximo 128 MB de arquivos. Caso esse limite seja ultrapassado, o sistema impedirá o salvamento. Para evitar, salve os arquivos aos poucos, enviando apenas alguns por vez (faça o upload a cada pequeno bloco de arquivos).'

const HTTP_CONFLICT_STATUS = 409

export default { HTTP_CONFLICT_STATUS, PAYLOAD_TOO_LARGE }
